import React from 'react';
import { AUTH_ACCESS, SUPER_ADMIN_AND_ADMIN_ACCESS } from './PermissionsRoutes';

const Forbidden = React.lazy(() => import('pages/common/Forbidden'))
const NotFound = React.lazy(() => import('pages/common/404'))
const ContractBoard = React.lazy(() => import('pages/contract-board/ContractBoard'))
const PasswordReset = React.lazy(() => import('pages/password-reset'))


const PF = '/home'
const RoutesHome = [
    { path: `${PF}/myinfo`, exact: true, name: '개인정보', element: <NotFound />, ...AUTH_ACCESS },
    { path: `${PF}/password-reset`, exact: true, name: '비밀번호 변경', element: <PasswordReset />, ...AUTH_ACCESS },
    { path: `${PF}/password-reset/write`, exact: true, name: '작성', element: <NotFound />, ...AUTH_ACCESS },
    { path: `${PF}/logout`, exact: true, name: '로그아웃', element: <NotFound />, ...AUTH_ACCESS },
    { path: `${PF}/contract-board`, exact: true, name: '계약연장 및 해지신청', element: <ContractBoard />, ...SUPER_ADMIN_AND_ADMIN_ACCESS },
    { path: `${PF}/contract-board/detail`, exact: true, name: '상세', element: <NotFound />, ...SUPER_ADMIN_AND_ADMIN_ACCESS },
    { path: `${PF}/contract-board/write`, exact: true, name: '작성', element: <NotFound />, ...SUPER_ADMIN_AND_ADMIN_ACCESS },
    { path: `${PF}/contract-board/rewrite`, exact: true, name: '수정', element: <NotFound />, ...SUPER_ADMIN_AND_ADMIN_ACCESS },
    { path: `${PF}/contract-board/delete`, exact: true, name: '삭제', element: <NotFound />, ...SUPER_ADMIN_AND_ADMIN_ACCESS },
    { path: `${PF}/qna`, exact: true, name: '문의사항', element: <NotFound />, ...AUTH_ACCESS },
    { path: `${PF}/qna/detail`, exact: true, name: '상세', element: <NotFound />, ...AUTH_ACCESS },
    { path: `${PF}/qna/detail/comment/write`, exact: true, name: '작성', element: <NotFound />, ...AUTH_ACCESS },
    { path: `${PF}/qna/detail/comment/rewrite`, exact: true, name: '수정', element: <NotFound />, ...AUTH_ACCESS },
    { path: `${PF}/qna/detail/comment/delete`, exact: true, name: '삭제', element: <NotFound />, ...AUTH_ACCESS },
    { path: `${PF}/qna/write`, exact: true, name: '작성', element: <NotFound />, ...AUTH_ACCESS },
    { path: `${PF}/qna/rewrite`, exact: true, name: '수정', element: <NotFound />, ...AUTH_ACCESS },
    { path: `${PF}/qna/delete`, exact: true, name: '삭제', element: <NotFound />, ...AUTH_ACCESS },
    { path: `${PF}/board`, exact: true, name: '사내게시판', element: <NotFound />, ...AUTH_ACCESS },
    { path: `${PF}/board/write`, exact: true, name: '작성', element: <NotFound />, ...AUTH_ACCESS },
    { path: `${PF}/board/rewrite`, exact: true, name: '수정', element: <NotFound />, ...AUTH_ACCESS },
    { path: `${PF}/board/delete`, exact: true, name: '삭제', element: <NotFound />, ...AUTH_ACCESS },
    { path: `${PF}/board/detail`, exact: true, name: '상세', element: <NotFound />, ...AUTH_ACCESS },
    { path: `${PF}/board/detail/comment/write`, exact: true, name: '작성', element: <NotFound />, ...AUTH_ACCESS },
    { path: `${PF}/board/detail/comment/rewrite`, exact: true, name: '수정', element: <NotFound />, ...AUTH_ACCESS },
    { path: `${PF}/board/detail/comment/delete`, exact: true, name: '삭제', element: <NotFound />, ...AUTH_ACCESS },
]

export default RoutesHome;
